/* eslint-disable */
export const isNotNullValues = (...values: any[]): boolean => {
  const temp = values.map((item) => (item !== null ? 1 : 0));
  return temp.every((x) => x > 0);
};
